import { z } from "zod";
import { zUid } from "./zUid";

export const zServiceInfo = z.object({
  id: zUid,
  name: z.string(),
  label: z.string().nullable().optional(),
  description: z.string(),
  endpoint: z.string().nullable(),
});

export type ZServiceInfo = z.infer<typeof zServiceInfo>;
